import React, { useState } from 'react';
import { FaSlidersH } from 'react-icons/fa';

const Step4Checks = () => {
  // Local state to manage which roles have active checklist mappings
  const [rolesChecks, setRolesChecks] = useState([
    { role: 'Head Chef', checks: ['Food Safety Check', 'Food Temperature Check', 'Opening Check'], extra: 2, enabled: true },
    { role: 'Server', checks: ['Cleaning Check', 'Closing Check', 'Allergen Check'], extra: 1, enabled: true },
    { role: 'Kitchen Assistant', checks: ['Temperature Check', 'Cleaning Check', 'Equipment Check'], extra: 0, enabled: true },
    { role: 'Manager', checks: ['Opening Check', 'Closing Check', 'Incident Log Review'], extra: 0, enabled: true },
    { role: 'Cleaner', checks: ['Cleaning Check'], extra: 0, enabled: true }
  ]);

  const toggleRoleApply = (index) => {
    const updated = [...rolesChecks];
    updated[index].enabled = !updated[index].enabled;
    setRolesChecks(updated);
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
      {/* Component Title and Configuration Buttons */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-md bg-blue-600 flex items-center justify-center text-white font-bold">4</div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Assign Checks</h2>
            <p className="text-xs text-gray-500">Choose which checks each role will be responsible for (links to the Checks module).</p>
          </div>
        </div>
        <button className="flex items-center gap-2 px-3 py-1.5 border border-gray-300 rounded-md text-xs font-medium text-gray-700 bg-white hover:bg-gray-50 transition shadow-sm">
          <FaSlidersH className="text-gray-400" /> Manage Check Templates
        </button>
      </div>

      {/* Checklist Mapping Layout Table */}
      <div className="overflow-x-auto rounded-lg border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200 text-left text-xs">
          <thead className="bg-slate-50 text-[10px] font-bold text-gray-400 uppercase tracking-wider">
            <tr>
              <th className="p-4 w-1/4">Role</th>
              <th className="p-4 w-3/5">Default Checks To Assign</th>
              <th className="p-4 text-center w-24">Apply to Rota</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {rolesChecks.map((item, idx) => (
              <tr key={idx} className="hover:bg-slate-50 transition">
                {/* Role Description Indicator */}
                <td className="p-4 font-semibold text-gray-800 flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-blue-500" />
                  {item.role}
                </td>

                {/* Configured Tag Checklists pills */}
                <td className="p-4">
                  <div className="flex flex-wrap gap-1.5">
                    {item.checks.map((check, cIdx) => (
                      <span key={cIdx} className="bg-slate-100 text-gray-600 px-2.5 py-1 rounded-md border border-gray-200 font-medium text-[11px]">
                        {check}
                      </span>
                    ))}
                    {item.extra > 0 && (
                      <span className="bg-blue-50 text-blue-600 px-2 py-1 rounded-md font-bold text-[11px] border border-blue-100">
                        +{item.extra}
                      </span>
                    )}
                  </div>
                </td>

                {/* Apply Active Status Toggle Switches */}
                <td className="p-4 text-center">
                  <div className="flex items-center justify-center gap-2">
                    <span className="text-[11px] font-medium text-gray-400 w-6">
                      {item.enabled ? 'Yes' : 'No'}
                    </span>
                    <button
                      type="button"
                      onClick={() => toggleRoleApply(idx)}
                      className={`w-9 h-5 flex items-center rounded-full p-0.5 transition-colors duration-200 focus:outline-none ${item.enabled ? 'bg-blue-600' : 'bg-gray-300'}`}
                    >
                      <div className={`bg-white w-3.5 h-3.5 rounded-full shadow transform transition-transform duration-200 ${item.enabled ? 'translate-x-4' : 'translate-x-0'}`} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Step4Checks;
